import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FaUser, FaEnvelope, FaUsers, FaCalendarAlt } from 'react-icons/fa';
import '../../../assets/css/customer/home/ReservationForm.css';

const ReservationForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    guests: '',
    date: '',
    event: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Reservation Data:', formData);
    alert('Reservation submitted successfully!');
  };

  return (
    <section className="reservation-section">
      <Container fluid>
        <Row className="align-items-center reservation-row">
          {/* Left Side - Reservation Form (MOVED HERE) */}
          <Col lg={6} md={12} className="reservation-form-col">
            <div className="reservation-form-content">
              {/* Heading */}
              <h2 className="reservation-heading">Make Reservations</h2>

              {/* Description */}
              <p className="reservation-description">
                Reserve Your Wedding Event.
              </p>

              {/* Reservation Form */}
              <form className="reservation-form" onSubmit={handleSubmit}>
                <Row className="form-row">
                  {/* Name Field */}
                  <Col md={6} sm={12} className="form-col">
                    <div className="form-group">
                      <FaUser className="input-icon" />
                      <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        className="form-input"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>

                  {/* Email Field */}
                  <Col md={6} sm={12} className="form-col">
                    <div className="form-group">
                      <FaEnvelope className="input-icon" />
                      <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        className="form-input"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="form-row">
                  {/* Guests Field */}
                  <Col md={6} sm={12} className="form-col">
                    <div className="form-group">
                      <FaUsers className="input-icon" />
                      <input
                        type="number"
                        name="guests"
                        placeholder="Guests"
                        className="form-input"
                        value={formData.guests}
                        onChange={handleChange}
                        min="1"
                        required
                      />
                    </div>
                  </Col>

                  {/* Date Field */}
                  <Col md={6} sm={12} className="form-col">
                    <div className="form-group">
                      <FaCalendarAlt className="input-icon" />
                      <input
                        type="date"
                        name="date"
                        placeholder="mm/dd/yyyy"
                        className="form-input"
                        value={formData.date}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>

                {/* Event Dropdown */}
                <div className="form-group full-width">
                  <select
                    name="event"
                    className="form-select"
                    value={formData.event}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Event</option>
                    <option value="wedding">Wedding Ceremony</option>
                    <option value="reception">Wedding Reception</option>
                    <option value="engagement">Engagement Party</option>
                    <option value="anniversary">Anniversary</option>
                    <option value="other">Other Event</option>
                  </select>
                </div>

                {/* Submit Button */}
                <div className="button-container">
                                 <button
                             type="button"
                         className="btn-make-reservation"
                     onClick={() => navigate("/customer/login")}
  >
                 Make Reservations
                </button>
              </div>
              </form>
            </div>
          </Col>

          {/* Right Side - Reserved Table Image (MOVED HERE) */}
          <Col lg={6} md={12} className="reservation-image-col">
            <div className="reserved-image-container">
              <img 
                src="https://i.pinimg.com/1200x/f4/ee/39/f4ee39fabae4eb094addb675ff9380d9.jpg" 
                alt="Reserved Table"
                className="reserved-table-photo"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ReservationForm;